import React from 'react';
import { motion } from 'framer-motion';
import { Brand } from '@/components/Brand';

// Branded full-screen "thinking" screen shown during transitions / heavy loads.
export const BrandedLoader = ({ label = 'Preparando tu cockpit...' }) => (
  <div data-testid="branded-loader" className="min-h-[60vh] w-full grid place-items-center">
    <div className="flex flex-col items-center gap-5">
      <motion.div animate={{ scale: [1, 1.08, 1], filter: ['drop-shadow(0 0 0px #3EB489)', 'drop-shadow(0 0 22px #3EB489)', 'drop-shadow(0 0 0px #3EB489)'] }} transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }}>
        <Brand size={72} showText={false} />
      </motion.div>
      <div className="flex items-center gap-2">
        <div className="w-2 h-2 rounded-full" style={{ background: '#3EB489', animation: 'ppb 1s infinite' }} />
        <div className="w-2 h-2 rounded-full" style={{ background: '#C9A84C', animation: 'ppb 1s infinite .15s' }} />
        <div className="w-2 h-2 rounded-full" style={{ background: '#A8E6CE', animation: 'ppb 1s infinite .3s' }} />
      </div>
      <span className="text-sm text-muted-foreground">{label}</span>
    </div>
    <style>{`@keyframes ppb{0%,100%{opacity:.3;transform:translateY(0)}50%{opacity:1;transform:translateY(-5px)}}`}</style>
  </div>
);

export const FullScreenLoader = () => (
  <div className="fixed inset-0 z-[100] grid place-items-center" style={{ background: '#07090A' }}>
    <BrandedLoader />
  </div>
);
